// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2yNfE","fullScreen":"style_fullScreen__gCsn1","hidden":"style_hidden__4IV9V"};